import { HttpResponse } from "@angular/common/http";
import { deprecate } from "util";



export class Cart{
    productId:string;
	cartId: string;
	/** 
	* @deprecated cartItemId should not be used. Instead use productId
	**/
	cartItemId: string;
	cartProductId:string;
}
export class cartDetail{
	/**
	 * @deprecated cartItemId should not be used. Instead use productId
	*/
	cartItemId:string;

	productId:string;
	quantity:number;
	cartProductId:string;
}
export class couponData{
	couponDiscount: number;
	grandTotal: number;
	 couponCode: string;        // 🔒 identity (FLAT100OFF)
  couponTitle: string; 
  name:string;
}

export class Delivery{
	deliveryCharge: 200;
	fastDeliveryApplied: boolean;
}
export class ApiResponse<T>{
	private _message:string;
	private _status:number;
	private _body:T;

    public get message(): string
 {
        return this._message;
    }

    public set message(message: string
) {
        this._message = message;
    }

    public get status(): number
 {
        return this._status;
    }

    public set status(status: number
) {
        this._status = status;
    }

    public get body(): T {
        return this._body;
    }

    public set body(body: T) {
        this._body = body;
    }

	private apiResponse:ApiResponse<any>;
	public constructor(status:number, message:string, body:T){
		this.message=message;
		this.status=status;
		this.body=body;
	}
	public  getSuccessApiResponse(data:T):ApiResponse<T>{
		return new ApiResponse<T>(200, "success", data);
	}
	

}